<div class="row">
  <div class="col"></div>
  <div class="col-2" style="text-align: right;" (click)="closeClicked()">
    <i class="material-icons" style="cursor: pointer; font-size: 28px;">
      cancel
    </i>
  </div>
</div><br>
<div class="row">
  <div class="col-6" style="text-align: right;">
    <label style="margin: 10px; font-size: 20px;">Enter the booth code to Search</label>
  </div>
  <div class="col">
    <input type="search" [matAutocomplete]="auto" #filter_term [(ngModel)]="search_term"
      style="border: 3px solid black; border-radius: 10px; text-indent: 10px; font-size: 20px; padding: 5px;" (ngModelChange)="searchBusinessCalled(filter_term.value)">
    <mat-autocomplete #auto="matAutocomplete">
      <mat-option *ngFor="let business of filtered_business_list" [value]="business.code"
        (click)="boothSelectedFromList(business.id)">
        <span>{{business.code}} - {{business.name}}</span>
      </mat-option>
    </mat-autocomplete>
  </div>
  <div class="col-2">
    <button [disabled]="selected_business_id == null" mat-button class="button-class" *ngIf="selected_business_id != null"
      (click)="confirmCicked(selected_business_id)">Choose</button>
  </div>
</div>
<div class="row">
  <div class="col" style="text-align: center;">
    <label style="font-size: 40px; color: orange;">Or</label>
  </div>
</div>
<div class="row" style="margin-bottom: 3% !important;">
  <div class="col" style="font-size: 32px; text-align: center;">
    Select booth from List or Map
  </div>
</div>
<div class="row">
  <div class="col-5" style="text-align: center;">
    <label style="font-size: 20px;">List</label>
  </div>
  <div class="col" style="text-align: center;">
    <label style="font-size: 20px;">Map</label>
  </div>
</div>
<div class="row" *ngIf="user_profile_id!= null">
  <div class="col-5" style="height: 1000px; overflow: auto;">
    <div class="row" style="margin-bottom: 3% !important;">
      <div class="col" style="font-size: 20px;">Booths near: {{pincode}}</div>
    </div>
    <mat-card *ngFor="let booth of booth_list" style="padding: 20px; color: black; box-shadow: 0px 1px 4px 0px black">
      <div class="row">
        <div class="col">
          <span>Shop name</span> : <span>{{booth['name']}}</span> &nbsp;<br>
          <span>Agent name</span> : <span>{{booth['agent_first_name']}}
            {{booth['last_name']}}</span><br>
          <span>Phone number</span> : <span>{{booth['agent_mobile_number']}}</span><br>
          <span>Address</span> : <span>{{booth['address']}}</span><br>
          <span>landmark</span> : <span>{{booth['landmark']}}</span><br>
          <span>Working hours</span> : <span>{{booth['working_hours_from']}} to
            {{booth['working_hours_to']}} </span>
        </div>
      </div><br>
      <div class="row">
        <div class="col" style="text-align: center;">
          <button (click)="confirmCicked(booth.business_id)" mat-button class="button-class">Choose</button>
        </div>
      </div>
    </mat-card>
  </div>
  <div class="col">
    <agm-map [latitude]="lat" [longitude]="lng" [zoom]="zoom" [fullscreenControl]='true' [mapTypeControl]='true'
      [zoomControl]='true'>
      <agm-marker *ngFor="let location of booth_lat_lng_data" [latitude]="location.lat" [longitude]="location.lng"
        iconUrl="http://maps.google.com/mapfiles/ms/icons/red-dot.png" (markerClick)="onBoothSelect(location)">
        <agm-info-window>
          {{location.business_code}}
        </agm-info-window>
      </agm-marker>
    </agm-map>
  </div>
</div>
